import { Button } from "./ui/button";
import { Menu, X } from "lucide-react";
import { useState } from "react";

export function Header() {
  const [isOpen, setIsOpen] = useState(false);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    element?.scrollIntoView({ behavior: "smooth" });
    setIsOpen(false);
  };

  return (
    <header className="fixed left-0 right-0 top-0 z-50 border-b border-gray-800 bg-gray-950/95 backdrop-blur-sm">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex h-16 items-center justify-between">
          <div className="flex items-center gap-2">
            <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-gradient-to-br from-blue-500 to-emerald-500 p-1">
              <svg viewBox="0 0 100 100" fill="none" className="h-full w-full">
                {/* Gordian Knot - Complex interwoven path */}
                <path
                  d="M50 10 C 65 10, 75 20, 75 35 C 75 42, 72 48, 65 52 C 72 56, 75 62, 75 69 C 75 84, 65 94, 50 94 C 35 94, 25 84, 25 69 C 25 62, 28 56, 35 52 C 28 48, 25 42, 25 35 C 25 20, 35 10, 50 10 Z"
                  stroke="white"
                  strokeWidth="3"
                  fill="none"
                  opacity="0.9"
                />
                <path
                  d="M 30 30 C 40 25, 60 25, 70 30 M 70 30 C 75 40, 75 60, 70 70 M 70 70 C 60 75, 40 75, 30 70 M 30 70 C 25 60, 25 40, 30 30"
                  stroke="white"
                  strokeWidth="3"
                  fill="none"
                  opacity="0.7"
                />
                {/* Crossing loops */}
                <path
                  d="M 38 25 Q 50 35, 62 25 M 38 75 Q 50 65, 62 75"
                  stroke="white"
                  strokeWidth="2.5"
                  fill="none"
                  opacity="0.85"
                />
                <path
                  d="M 25 38 Q 35 50, 25 62 M 75 38 Q 65 50, 75 62"
                  stroke="white"
                  strokeWidth="2.5"
                  fill="none"
                  opacity="0.85"
                />
                {/* Center weave */}
                <ellipse
                  cx="50"
                  cy="50"
                  rx="12"
                  ry="18"
                  stroke="white"
                  strokeWidth="2.5"
                  fill="none"
                  opacity="0.8"
                />
                <ellipse
                  cx="50"
                  cy="50"
                  rx="18"
                  ry="12"
                  stroke="white"
                  strokeWidth="2.5"
                  fill="none"
                  opacity="0.8"
                />
              </svg>
            </div>
            <span className="text-xl text-white">Brenneman Systems</span>
          </div>

          <nav className="hidden items-center gap-8 md:flex">
            <button
              onClick={() => scrollToSection("services")}
              className="text-gray-400 transition-colors hover:text-white"
            >
              Offers
            </button>
            <button
              onClick={() => scrollToSection("benefits")}
              className="text-gray-400 transition-colors hover:text-white"
            >
              Why Us
            </button>
            <button
              onClick={() => scrollToSection("process")}
              className="text-gray-400 transition-colors hover:text-white"
            >
              Process
            </button>
            <button
              onClick={() => scrollToSection("contact")}
              className="text-gray-400 transition-colors hover:text-white"
            >
              Contact
            </button>
            <Button
              onClick={() => scrollToSection("contact")}
              className="bg-gradient-to-r from-blue-500 to-emerald-500 text-white hover:from-blue-600 hover:to-emerald-600"
            >
              Get Started
            </Button>
          </nav>

          <button
            className="text-white md:hidden"
            onClick={() => setIsOpen(!isOpen)}
            aria-label="Toggle menu"
          >
            {isOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>

        {isOpen && (
          <nav className="space-y-4 py-4 md:hidden">
            <button
              onClick={() => scrollToSection("services")}
              className="block w-full text-left text-gray-400 hover:text-white"
            >
              Offers
            </button>
            <button
              onClick={() => scrollToSection("benefits")}
              className="block w-full text-left text-gray-400 hover:text-white"
            >
              Why Us
            </button>
            <button
              onClick={() => scrollToSection("process")}
              className="block w-full text-left text-gray-400 hover:text-white"
            >
              Process
            </button>
            <button
              onClick={() => scrollToSection("contact")}
              className="block w-full text-left text-gray-400 hover:text-white"
            >
              Contact
            </button>
            <Button
              onClick={() => scrollToSection("contact")}
              className="w-full bg-gradient-to-r from-blue-500 to-emerald-500 text-white hover:from-blue-600 hover:to-emerald-600"
            >
              Get Started
            </Button>
          </nav>
        )}
      </div>
    </header>
  );
}
